/* ASSIGNMENT */
export enum AssignmentStateEnum {
    IN_LAVORAZIONE = 'IN_LAVORAZIONE',
    IN_ESECUZIONE = 'IN_ESECUZIONE',
    COMPLETATO = 'COMPLETATO',
    REVOCATO = 'REVOCATO'
}

export enum contractType {
    STANDARD = 'STANDARD',
    C008 = 'C08'
}

export interface AssignmentCreationDTO {
    assignmentDate?: Date
    year?: string
    assignmentPlace?: string
    norm?: string
    departureProtocolId?: string
    personalManagementId?: string
    pmContractId?: string
    reference?: string
    headQuarterId?: string
    contractType?: contractType
}

export interface AssignmentErrorsDTO {
    personalManagementId: boolean
    departureProtocolId: boolean
    norm: boolean
    assignmentPlace: boolean
    assignmentDate: boolean
    year: boolean
    headQuarterId: boolean
}

export interface AssignmentUploadDTO {
    file: File
    userId: string
    name: string
}

export interface FileSignedErrorsDTO {
    file: boolean
}

export interface AssignmentUploadErrorsDTO {
    file: boolean
    userId: boolean
    name: boolean
}

export interface AssignmentUpdateDTO {
    pmContractId?: string
    reference?: string
    revocationProtocolId?: string
    state?: AssignmentStateEnum
    signedAssignmentLetterId?: string
    departureProtocolId?: string
    assignmentPlace?: string
    isAccepted?: boolean
    ucoVerificationDate?: Date
    ucoVerificationOfficerId?: string
}

export interface AssignmentDTO {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    deletedAt: Date | null
    assignmentDate: Date
    year: string
    assignmentPlace: string
    norm: string
    departureProtocolId: string
    departureProtocolInfo: string
    departureProtocolHeadQuarter: string
    personalManagementId: string
    personalManagementInfo: string
    inspectorCode: string
    pmContractId: string
    pmContractType: string
    reference: string
    revocationProtocolId: string
    revocationProtocolInfo: string
    state: AssignmentStateEnum
    signedAssignmentLetterId: string
    signedAssignmentLetterInfo: string
    isAccepted: boolean
    ucoVerificationDate?: Date
    ucoVerificationOfficerId?: string
    ucoVerificationOfficerInfo: string
    fileId?: number
}

export interface GetAllAssignmentDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: AssignmentDTO[]
}

export interface GetAllAssignmentFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    year?: string
    inspectorCode?: string
    reference?: string
}

/* INSPECTION VISIT */

export enum InspectionVisitTypeEnum {
    ANNUNCIATA = 'ANNUNCIATA',
    NON_ANNUNCIATA = 'NON_ANNUNCIATA',
    FASE_DI_AVVIO = 'FASE_DI_AVVIO',
    BIO_FASE_DI_AVVIO_CONTROLLO_IN_INGRESSO = 'BIO_FASE_DI_AVVIO_CONTROLLO_IN_INGRESSO',
    BIO_CONTROLLO_ORDINARIO_ANNUALE = 'BIO_CONTROLLO_ORDINARIO_ANNUALE',
    BIO_CONTROLLO_SUPPLEMENTARE_A_CAMPIONE = 'BIO_CONTROLLO_SUPPLEMENTARE_A_CAMPIONE',
    BIO_CONTROLLO_STRAORDINARIO_MIRATA = 'BIO_CONTROLLO_STRAORDINARIO_MIRATA',
    SQNPI_INGRESSO = 'SQNPI_INGRESSO',
    SQNPI_ORDINARIA = 'SQNPI_ORDINARIA',
    SQNPI_STRAORDINARIA = 'SQNPI_STRAORDINARIA',
    DETERGENZA_INGRESSO = 'DETERGENZA_INGRESSO',
    DETERGENZA_ORDINARIA = 'DETERGENZA_ORDINARIA',
    DETERGENZA_STRAORDINARIA = 'DETERGENZA_STRAORDINARIA',
    QS_INGRESSO = 'QS_INGRESSO',
    QS_ORDINARIA = 'QS_ORDINARIA',
    QS_STRAORDINARIA = 'QS_STRAORDINARIA',
    GGAP_PRE_AUDIT = 'GGAP_PRE_AUDIT',
    GGAP_AUDIT_INIZIALE_DI_CERTIFICAZIONE = 'GGAP_AUDIT_INIZIALE_DI_CERTIFICAZIONE',
    GGAP_ESTENSIONE_PRODOTTI = 'GGAP_ESTENSIONE_PRODOTTI',
    GGAP_RINNOVO = 'GGAP_RINNOVO',
    GGAP_RI_CERTIFICAZIONE = 'GGAP_RI_CERTIFICAZIONE',
    GGAP_STRAORDINARIA = 'GGAP_STRAORDINARIA',
    GGAP_ESTENSIONE_AZIENDE_AGRICOLE = 'GGAP_ESTENSIONE_AZIENDE_AGRICOLE',
    BIO_CONTROLLO_AGGIUNTIVO = 'BIO_CONTROLLO_AGGIUNTIVO',
    RZ_INGRESSO = 'RZ_INGRESSO',
    RZ_ORDINARIA = 'RZ_ORDINARIA',
    RZ_STRAORDINARIA = 'RZ_STRAORDINARIA',
    NF_INGRESSO = 'NF_INGRESSO',
    NF_ORDINARIA = 'NF_ORDINARIA',
    NF_STRAORDINARIA = 'NF_STRAORDINARIA'

}

export enum InspectionVisitModeEnum {
    ANNUNCIATA = 'ANNUNCIATA',
    NON_ANNUNCIATA = 'NON_ANNUNCIATA',
    CON_PREAVVISO = 'CON_PREAVVISO',
    SENZA_PREAVVISO = 'SENZA_PREAVVISO'
}

export enum InspectionVisitControlResultEnum {
    CONFORME = 'CONFORME',
    NON_CONFORME = 'NON_CONFORME'
}

export enum InspectionVisitNonComplianceTypeEnum {
    NESSUNA = 'NESSUNA',
    SCARSA_ENTITA = 'SCARSA_ENTITA',
    GRAVE = 'GRAVE',
    CRITICA = 'CRITICA'
}

export enum IVAuditedActivityEnum {
    AGRICOLTURA_BIOLOGICA = 'AGRICOLTURA_BIOLOGICA',
    DEMETER = 'DEMETER',
    BIO_SUISSE = 'BIO_SUISSE'
}

export enum productionTypeSQNPI {
    PRODUZIONE = 'PRODUZIONE',
    PREPARAZIONE = 'PREPARAZIONE',
    DISTRIBUZIONE = 'DISTRIBUZIONE',
    ORGANIZZAZIONE = 'ORGANIZZAZIONE'
}

export enum IVActivityEnum {
    A_PRODUTTORE_ESCLUSIVO = 'A_PRODUTTORE_ESCLUSIVO',
    AB_PRODUTTORE_PREPARATORE = 'AB_PRODUTTORE_PREPARATORE',
    ABC_PRODUTTORE_PREPARATORE_IMPORTATORE = 'ABC_PRODUTTORE_PREPARATORE_IMPORTATORE',
    AC_PRODUTTORE_IMPORTATORE = 'AC_PRODUTTORE_IMPORTATORE',
    B_PREPARATORE_ESCLUSIVO = 'B_PREPARATORE_ESCLUSIVO',
    BC_PREPARATORE_IMPORTATORE = 'BC_PREPARATORE_IMPORTATORE',
    C_IMPORTATORE_ESCLUSIVO = 'C_IMPORTATORE_ESCLUSIVO',
    DIS_DISTRIBUZIONE_IMMISSIONE_SUL_MERCATO = 'DIS_DISTRIBUZIONE_IMMISSIONE_SUL_MERCATO',
    E_ESPORTATORE = 'E_ESPORTATORE',
    GO_GRUPPO_DI_OPERATORI = 'GO_GRUPPO_DI_OPERATORI',
    M_MANGIMI = 'M_MANGIMI',
    MAG_MAGAZZINAGGIO = 'MAG_MAGAZZINAGGIO',
    V_VITIVINICOLO = 'V_VITIVINICOLO'
}

export enum IVActivityTypeEnum {
    VEGETALE = 'VEGETALE',
    ZOOTECNIA = 'ZOOTECNIA',
    ACQUACOLTURA = 'ACQUACOLTURA',
    VITIVINICOLO = 'VITIVINICOLO',
    SEMENTIERO = 'SEMENTIERO',
    MANGIMI = 'MANGIMI',
    PUNTO_VENDITA_GDO = 'PUNTO_VENDITA_GDO'
}

export enum IVSQNPIActivityEnum {
    PRODUZIONE = 'PRODUZIONE',
    PREPARAZIONE = 'PREPARAZIONE',
    DISTRIBUZIONE = 'DISTRIBUZIONE',
    ORGANIZZAZIONE = 'ORGANIZZAZIONE'
}

export interface InspectionVisitCreationDTO {
    assignmentId?: string
    customerId?: string
    annualControlPlaneDetailId?: string
    inLocoControl?: boolean
    documentalControl?: boolean
    remoteVisit?: boolean
    type?: InspectionVisitTypeEnum
    mode?: InspectionVisitModeEnum
    expirationDate?: Date
    expirationDateExtended?: Date
    licenseeOperator?: boolean
    controlDetail?: string
    specification?: string
    bioNotificationId?: string
    ggNotificationId?: string
    sqnpiNotificationId?: string
    inSupportSubject?: string
    inSupportSubjectEntity?: string
    inAccompanyingSubject?: string
    inAccompanyingSubjectEntity?: string
    expertSubject?: string
    traineeTechnician?: string
    plannedSampling?: boolean
    materialType?: string
    firstEnvelope?: string
    secondEnvelope?: string
    thirdEnvelope?: string
    fourthEnvelope?: string
    auditedActivities: IVAuditedActivityEnum[]
    activity?: IVActivityEnum
    activityTypes: IVActivityTypeEnum[]
    addOnIds: string[]
    ggLotNumber?: number
    ggControlDuration?: string
    ggProducts?: string
    ggTeamLeader?: string
    ggInspector?: string
    ggObserver?: string
    ggExpert?: string
    sqnpiControlActivities: IVSQNPIActivityEnum[]
    officerId?: string
}

export interface InspectionVisitUpdateDTO {
    type?: InspectionVisitTypeEnum
    mode?: InspectionVisitModeEnum
    expirationDate?: Date
    expirationDateExtended?: Date
    licenseeOperator?: boolean
    controlDetail?: string
    specification?: string
    bioNotificationId?: string
    ggNotificationId?: string
    sqnpiNotificationId?: string
    plannedVisitDate?: Date // data prevista per il controllo
    effectiveVisitDate?: Date // data effettiva per il controllo
    reportProtocolId?: string
    inLocoControl?: boolean
    documentalControl?: boolean
    remoteVisit?: boolean
    remoteVisitProtocolId?: string
    inMoreDays?: boolean
    daysNumber?: number
    startingEndingVisits: string[]
    visitDate?: Date // data controllo da remoto
    result?: InspectionVisitControlResultEnum // esito controllo
    nonComplianceType?: InspectionVisitNonComplianceTypeEnum // tipologia non conformità
    instructorNote?: string // note ispettore
    isRevoked?: boolean
    revokedProtocolId?: string
    isNotPerformed?: boolean
    exclusionProtocolId?: string
    exclusionDate?: Date
    isReportReturned?: boolean
    restitutionProtocolId?: string
    returnedReportProtocolId?: string
    administrativeVerification?: boolean
    note?: string
    materialType?: string
    plannedSampling?: boolean
    firstEnvelope?: string
    secondEnvelope?: string
    thirdEnvelope?: string
    fourthEnvelope?: string
    auditedActivities: IVAuditedActivityEnum[]
    activity?: IVActivityEnum
    activityTypes: IVActivityTypeEnum[]
    addOnIds: string[]
    ggLotNumber?: number
    ggControlDuration?: string
    ggProducts?: string
    ggTeamLeader?: string
    ggInspector?: string
    ggObserver?: string
    ggExpert?: string
    sqnpiControlActivities: IVSQNPIActivityEnum[]
    inSupportSubject?: string
    inSupportSubjectEntity?: string
    inAccompanyingSubject?: string
    inAccompanyingSubjectEntity?: string
    expertSubject?: string
    traineeTechnician?: string
}

export interface InspectionVisitDTO {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    deletedAt: Date | null
    assignmentId: string
    customerId: string
    annualControlPlaneDetailId: string
    annualControlPlaneDetailPeriodicity: number[]
    type: InspectionVisitTypeEnum
    mode: InspectionVisitModeEnum
    expirationDate: Date
    expirationDateExtended?: Date
    licenseeOperator: boolean
    controlDetail: string
    specification: string
    bioNotificationId: string
    ggNotificationId: string
    sqnpiNotificationId: string
    inLocoControl: boolean
    administrativeVerification: boolean
    exclusionDate: Date
    materialType: string
    firstEnvelope: string
    secondEnvelope: string
    thirdEnvelope: string
    fourthEnvelope: string
    addOnIds: string[]
    ggLotNumber: number
    ggControlDuration: string
    ggProducts: string
    ggTeamLeader: string
    ggInspector: string
    ggObserver: string
    ggExpert: string
    sqnpiControlActivities: IVSQNPIActivityEnum[]
    inSupportSubject: string
    inSupportSubjectEntity: string
    inAccompanyingSubject: string
    inAccompanyingSubjectEntity: string
    expertSubject: string
    traineeTechnician: string
    plannedVisitDate: Date
    effectiveVisitDate: Date
    reportProtocolId: string
    reportProtocolInfo: string
    documentalControl: boolean
    remoteVisit: boolean
    remoteVisitProtocolId: string
    remoteVisitProtocolInfo: string
    inMoreDays: boolean
    daysNumber: number
    startingEndingVisits: string[]
    visitTotalHours: string | number
    visitTotalMinutes: string | number
    visitDate: Date
    result: InspectionVisitControlResultEnum
    nonComplianceType: InspectionVisitNonComplianceTypeEnum
    instructorNote: string
    isRevoked: boolean
    revokedProtocolId: string
    revokedProtocolInfo: string
    isNotPerformed: boolean
    exclusionProtocolId: string
    exclusionProtocolInfo: string
    isReportReturned: boolean
    restitutionProtocolId: string
    restitutionProtocolInfo: string
    returnedReportProtocolId: string
    returnedReportProtocolInfo: string
    note: string
    plannedSampling: boolean
    auditedActivities: IVAuditedActivityEnum[]
    activity: IVActivityEnum
    activityTypes: IVActivityTypeEnum[]
    customerCompanyName: string
    customerClientCode: string
    fileId: File
}

export interface GetAllInspectionVisitDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: InspectionVisitDTO[]
}

export interface GetAllInspectionVisitFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    year?: string
    assignmentId?: string
    inspectionVisitId?: string
    customerId?: string
}

export interface InspectionVisitTurnOverFiltersDTO {
    inspectorCode?: string
    customerId?: string
}

export interface TurnOverResponseDTO {
    message: string
    lastInspectorCode: string
    lastInspectorInfo: string
}

export interface assignmentLetterDocxDTO {
    id: string
    assignmentLetterType: assignmentLetterTypeEnum
}

export enum assignmentLetterTypeEnum {
    C08 = 'C08',
    C09 = 'C09',
    C10 = 'C10',
}

/* RESULT CONTROL ACTIVITY */

export enum ResultControlComplianceEnum {
    CONFORME = 'CONFORME',
    NON_CONFORME = 'NON_CONFORME',
    NON_APPLICABILE = 'NON_APPLICABILE'
}

export interface ResultControlActivityCreationDTO {
    inspectionVisitId?: string
    vegetalActivityResult?: ResultControlComplianceEnum
    processingActivityResult?: ResultControlComplianceEnum
    livestockActivityResult?: ResultControlComplianceEnum
    importationActivityResult?: ResultControlComplianceEnum
    blockedEvaluation?: boolean
    evaluationDate?: Date
    evaluationNote?: string
    checkProcessingActivity?: boolean
    note?: string
    serviceTypecode?: string
    unitEmployed?: number
    customerBillingWorksheetId?: string
    officerId?: string
}

export interface ResultControlActivityUpdateDTO {
    vegetalActivityResult?: ResultControlComplianceEnum
    processingActivityResult?: ResultControlComplianceEnum
    livestockActivityResult?: ResultControlComplianceEnum
    importationActivityResult?: ResultControlComplianceEnum
    blockedEvaluation?: boolean
    evaluationDate?: Date
    evaluationNote?: string
    checkProcessingActivity?: boolean
    note?: string
    serviceTypecode?: string
    unitEmployed?: number
    customerBillingWorksheetId?: string
    officerId?: string
}

export interface ResultControlActivityDTO {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    deletedAt: Date | null
    inspectionVisitId: string
    vegetalActivityResult: ResultControlComplianceEnum
    processingActivityResult: ResultControlComplianceEnum
    livestockActivityResult: ResultControlComplianceEnum
    importationActivityResult: ResultControlComplianceEnum
    blockedEvaluation: boolean
    evaluationDate: Date
    evaluationNote: string
    checkProcessingActivity: boolean
    note: string
    serviceEntityId: string
    effectiveEvaluationDate: Date
    serviceTypecode: string
    unitEmployed: number
    customerBillingWorksheetId: string
    officerId: string
    officerInfo: string
}

export interface GetAllResultControlActivityDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: ResultControlActivityDTO[]
}

export interface GetAllResultControlActivityFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    year?: string
    inspectionVisitId?: string
}